module.exports = __webpack_public_path__ + "img/digital.3ce10007.png";